import $ from 'jquery';

(function(){
    'use strict';
    
    var initAccordion = function() {
        var accType = $(".accordion").data("accordion-type");
    
        $('.accordion .accordion-title').click(function() {
            var accBtn = $(this);
            var accItem = $(this).parent();
    
            if (accType == "multiple") {
                if (accItem.hasClass('active')) {
                    accItem.removeClass('active');
                    accItem.find(".accordion-content").slideUp(300);
                    accBtn.attr('aria-expanded', 'false');
                }
                else {
                    accItem.addClass('active');
                    accItem.find('.accordion-content').slideDown(300);
                    accBtn.attr('aria-expanded', 'true');
                }
            } 
            else {
                if (accItem.hasClass('active')) {
                    accItem.removeClass('active');
                    accItem.find(".accordion-content").slideUp(300);
                    accBtn.attr('aria-expanded', 'false');
                }
                else {
                    $(".accordion .accordion-item").removeClass('active');
                    $(".accordion .accordion-content").slideUp(300);
                    $(".accordion .accordion-title").attr('aria-expanded', 'false');
                    accItem.addClass('active');
                    accItem.find('.accordion-content').slideDown(300);
                    accBtn.attr('aria-expanded', 'true');
                }
            }
        });
    };

    $(document).ready(function() {
        initAccordion();
    });
    
}());
